/**
 * <s-dismissible-details> — wraps one native <details> popover card (hero
 * product tag, discount-tier card) and closes it on an outside click or Escape,
 * returning focus to its summary on Escape. Opening and closing by the summary
 * stay native, so the card still works before this script loads.
 */
class SDismissibleDetails extends HTMLElement {
  connectedCallback() {
    this.details = this.querySelector('details');
    if (!this.details) return;

    this.handleDocumentClick = (event) => {
      if (this.details.open && !this.contains(event.target)) this.details.open = false;
    };
    this.handleKeydown = (event) => {
      if (event.key !== 'Escape' || !this.details.open) return;
      this.details.open = false;
      this.details.querySelector('summary')?.focus();
    };

    document.addEventListener('click', this.handleDocumentClick);
    document.addEventListener('keydown', this.handleKeydown);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.handleDocumentClick);
    document.removeEventListener('keydown', this.handleKeydown);
  }
}

if (!customElements.get('s-dismissible-details')) {
  customElements.define('s-dismissible-details', SDismissibleDetails);
}
